import { extract as extractCssUrl } from 'js/main/package/extract-css-url';
import { getWebPUrl } from 'js/main/package/get-webp-url';
import { preloadImage } from 'js/main/package/preload-image';
import { hasWebPBasicSupport } from 'js/main/package/has-webp-support';

export async function applyBackgroundImageFromCssRule(Element, cssRule) {
    const cssUrl = extractCssUrl(cssRule);
    const webpUrl = getWebPUrl(cssUrl);

    let url = cssUrl;

    // if (await hasWebPBasicSupport()) {
    //     const webpAvailable = await preloadImage(webpUrl);

    //     if (webpAvailable) {
    //         url = webpUrl;
    //     }
    // }

    $(Element).css({
        backgroundImage: `url(${url})`,
    });
}



// WEBPACK FOOTER //
// ./js/main/package/apply-background-img-from-css-rule.js